// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
  $ModelUpsertParams,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';

// Types
type $Props = $Translate & {
  item: $Model<'RegattaCourse'> | $ModelUpsertParams<'RegattaCourse'>;
};

const RegattaCourseFieldsView = function ({
  item,
  t,
}: $Props) {
  return (
    <Row>
      <Col>
        <AvField
          label={t('Title')}
          name={'Name'}
          required
          value={item.Name}
        />
      </Col>
    </Row>
  );
};

export default RegattaCourseFieldsView;
